"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IPNumType.js.map